import type { Vehicle } from "@/types";

// Normalização única do estado de bloqueio/ignição — usada pelo card da
// frota, painel de detalhes, aba Sensores e marcador do mapa. Todos leem
// estes valores a partir do MESMO dado (Vehicle.blocked/Vehicle.ignition,
// que vêm de position.attributes.blocked/ignition via vehiclesService), sem
// duplicar a lógica nem criar um estado local separado da fonte real —
// evita a divergência entre mapa/frota/sensores/painel depois de um comando
// de bloqueio (ver bug de sincronização 2026-08-11).

export type IgnitionState = "on" | "off" | "unknown";

export function isVehicleBlocked(v: Pick<Vehicle, "blocked">): boolean {
  return v.blocked === true;
}

// Alimentação externa (Sensores). Assim como blocked, o padrão sem sinal
// nenhum (nem ao vivo, nem em cache) é "ligada" — fail-safe visual: só cai
// para Desligado quando o rastreador reporta explicitamente um alarme de
// corte de energia/violação de bateria (ver powerStateFromAlarm em
// vehicles.service.ts).
export function isVehiclePowered(v: Pick<Vehicle, "powered">): boolean {
  return v.powered !== false;
}

// Nem todo pacote de posição reporta o atributo de ignição (varia por
// protocolo do rastreador). Sem o atributo, o estado é DESCONHECIDO — nunca
// cai para "ligada" por padrão, porque isso mascarava o motor já desligado
// (ex.: logo depois de um comando de bloqueio, antes do rastreador
// reportar a posição seguinte).
export function ignitionState(v: Pick<Vehicle, "ignition">): IgnitionState {
  if (v.ignition === true) return "on";
  if (v.ignition === false) return "off";
  return "unknown";
}

export function ignitionLabel(state: IgnitionState): string {
  return state === "on" ? "Ligada" : state === "off" ? "Desligada" : "Desconhecida";
}
